import { SubscriptionType } from './subscription';

export interface SubscriptionConfigType {
  prefix: string;
  name: string;
  id: string;
}

export const SubscriptionsConfig: Record<SubscriptionType, SubscriptionConfigType> = {
  [SubscriptionType.Modular]: {
    name: 'Modular',
    id: 'modular',
    prefix: 'app',
  },
  costEstimate: null,
  kreoPlan: null,
  takeoff2D: null,
  takeoff3D: null,
};
